import React from "react";
import "./SiteProfileTable.less";
import {
  apiRequest,
  apiPost,
  apiPostAsync
} from "../../../../utils/api_service";
import { API_URL } from "../../../../constants/api";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { Tooltip, TextField, Button } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import moment from "moment";
import { ShowToast, toastType } from "../../../../utils/toast-service";
import EditIcon from "@material-ui/icons/Edit";
import CancelIcon from "@material-ui/icons/Cancel";
import {
  GetSectionPermission,
  PaperComponent,
  numberWithCommas
} from "../../../../utils/helper";
import { SECTIONS } from "../../../../constants/appConstants";
import { getDwId } from "../../../../utils/generic";
import TenantContact from "./TenantContact";

class SiteProfileTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      siteProfileTableList: [],
      open: false,
      index: null,
      ValuesToUpdate: [],
      siteProfileCapacityTableList: [],
      editFields: false,
      editCapacity: false,
      propertyId: 1,
      tableName: this.props.table,
    };
  }

  componentDidMount() {
    // this.setState({
    //   tableName: this.props.table,
    //   editFields: false,
    //   editCapacity: false,
    //   datacenterList: this.props.datacenterList,
    // });
    // this.GetSteProfileDataByDate(this.props.propertyId, this.props.startDate);
    // this.getCapacityTableDetails(this.props.propertyId, false);
  }
  componentWillReceiveProps(newProps) {
    if (
      newProps.propertyId != this.props.propertyId ||
      newProps.table != this.props.table ||
      newProps.startDate != this.props.startDate ||
      newProps.rerender != this.props.rerender ||
      newProps.datacenterList != this.props.datacenterList ||
      newProps.isChanged != this.props.isChanged ||
      newProps.endDate != this.props.endDate
    ) {
      this.GetSteProfileDataByDate(
        newProps.propertyId,
        newProps.startDate,
        newProps.endDate
      );
      this.getCapacityTableDetails(
        newProps.propertyId,
        false,
        newProps.startDate,
        newProps.endDate
      );
      this.setState({
        tableName: newProps.table,
        editFields: false,
        editCapacity: false
        // datacenterList: this.props.datacenterList,
      });
    }
  }

  /** call on open click */
  handleClickOpen = index => {
    this.setState({ open: true, index: index });
  };

  /** call on close */
  handleClose = () => {
    this.setState({ open: false, index: null });
  };

  /** site profile data by date */
  GetSteProfileDataByDate = (propertyId, startDate, endDate) => {
    const params = {
      propertyId: propertyId,
      startDate: startDate,
      endDate: endDate
    };

    apiRequest({
      url: API_URL.datacenter.GetTenantDetailsByProperty,
      params
    }).then(({ data: List }) => {
      this.setState({
        siteProfileTableList: List,
        propertyId: propertyId
      });
    });
  };

  /** capacity table details */
  getCapacityTableDetails = (propertyId, callKWApi, startDate, endDate) => {
    let params = {
      propertyId: propertyId,
      startDate: moment(startDate).format("YYYY-MM-DD"),
      endDate: moment(endDate).format("YYYY-MM-DD")
    };
    apiRequest({
      url: API_URL.datacenter.GetDataHallCapacityByProperty,
      params
    }).then(({ data: List }) => {
      //console.log(List);

      const power = List.filter(function(x) {
        if (x.AttributeName == "Unleased Capacity") {
          return x.Power;
        }
      });
      const LeasedCapacity = List.filter(function(x) {
        if (x.AttributeName == "Leased Capacity") {
          return x.Power;
        }
      });
      const InstalledCapacity = List.filter(function(x) {
        if (x.AttributeName == "Total Capacity") {
          return x.Power;
        }
      });

      if ((power[0] || []).Power < 0) {
        ShowToast(
          "Caution! Data hall leased capacity is greater than total capacity",
          toastType.WARNING,
          5000,
          200
        );
      }
      this.setState({
        siteProfileCapacityTableList: List,
        propertyId: propertyId
      });
      const dwPropertyId = getDwId(propertyId, this.props.datacenterList);
      //console.log(power);
      if (callKWApi && dwPropertyId != undefined && dwPropertyId > 0) {
        if (
          LeasedCapacity.length > 0 &&
          LeasedCapacity[0] != undefined &&
          LeasedCapacity[0].Power != undefined
        ) {
          params = {
            propertyKey: dwPropertyId.toString(),
            attributeValue: LeasedCapacity[0].Power.toString(),
            attributeType: "Leased KW"
          };

          apiPostAsync({
            url: API_URL.finance.UpdateKwForProperty,
            postBody: params
          }).then(() => {
            //console.log(response);
          });
        }

        if (
          InstalledCapacity.length > 0 &&
          InstalledCapacity[0] != undefined &&
          InstalledCapacity[0].Power != undefined
        ) {
          const InstalledParams = {
            propertyKey: dwPropertyId.toString(),
            attributeValue: InstalledCapacity[0].Power.toString(),
            attributeType: "Installed KW"
          };
          apiPostAsync({
            url: API_URL.finance.UpdateKwForProperty,

            postBody: InstalledParams
          }).then(() => {
            //console.log(response);
          });
        }
      }
    });
  };

  /** handle change value */
  handleChangeValue(value, attributeId) {
    value = parseFloat(value);
    const TempArray = this.state.ValuesToUpdate;
    if (value != "" && attributeId !== "" && !isNaN(value)) {
      TempArray.push({ attributeId, value });
      this.setState({ ValuesToUpdate: TempArray });
    }

    if (value == 0) {
      TempArray.push({ attributeId, value });
      this.setState({ ValuesToUpdate: TempArray });
    }
    if (isNaN(value)) {
      ShowToast("Please enter digits only", toastType.ERROR, 5000, 200);
    }
  }

  handleChange = (value, sectionDetailId) => {
    //console.log("Handel Change called");
    const postBody = {
      propertyId: this.props.propertyId,
      sectionDetailId: sectionDetailId,
      attributeValue: value,
      startDate: moment(this.props.startDate).format("YYYY-MM-DD"),
      endDate: moment(this.props.endDate).format("YYYY-MM-DD")
    };

    apiPost({
      url: API_URL.datacenter.UpdateDataCenterAttribute,
      params: [],
      postBody: postBody
    }).then(() => {
      this.setState({ editCapacity: false });
      ShowToast("Record updated successfully.", toastType.SUCCESS, 5000, 200);
      this.getCapacityTableDetails(
        this.state.propertyId,
        true,
        this.props.startDate,
        this.props.endDate
      );
    });
  };

  /** update tenant values */
  updateTenantValues = () => {
    (this.state.ValuesToUpdate || []).map((item) => {
      const bodyToPost = {
        tenantDetailId: item.attributeId,
        powerLeased: parseFloat(item.value),
        startDate: moment(this.props.startDate).format("YYYY-MM-DD"),
        endDate: moment(this.props.endDate).format("YYYY-MM-DD")
      };
      //console.log("update Tenant Values called");
      apiPost({
        url: API_URL.datacenter.UpdateDataCenterTenant,
        params: [],
        postBody: bodyToPost
      }).then(({ data: response }) => {
        if (response.success == true) {
          this.GetSteProfileDataByDate(
            this.state.propertyId,
            this.props.startDate,
            this.props.endDate
          );
          ShowToast(
            "Record updated successfully.",
            toastType.SUCCESS,
            5000,
            200
          );
          this.props.onUpdate();
          this.getCapacityTableDetails(
            this.state.propertyId,
            true,
            this.props.startDate,
            this.props.endDate
          );
        }
      });
    });

    this.setState({ ValuesToUpdate: [], editFields: false });
  };
  render() {
    const { siteProfileTableList, index } = this.state;
    
    const selectedTenantId = siteProfileTableList[index]?.TenantId;

    const TenantListingPermission = GetSectionPermission(
      SECTIONS.SITE_PROFILE,
      SECTIONS.TENANT_LISTING
    );

    const DataHallPermission = GetSectionPermission(
      SECTIONS.SITE_PROFILE,
      SECTIONS.DATA_HALL_CAPACITY
    );

    const IsTenantListingPermissionVisible =
      TenantListingPermission.accessTypeId > 0 &&
      TenantListingPermission.accessTypeId < 4
        ? true
        : false;

    const IsDataHallPermissionVisible =
      DataHallPermission.accessTypeId > 0 && DataHallPermission.accessTypeId < 4
        ? true
        : false;

    const IsDataHallPermissionEditable =
      DataHallPermission.accessTypeId > 1 ? true : false;
    const IsTenantListingPermissionEditable =
      TenantListingPermission.accessTypeId > 1 ? true : false;
    // const ShowData= permission.showData

    return (
      <div className={"site-profile-table-div"}>
        {this.state.ValuesToUpdate.length > 0 ? (
          <div className={"w-100 save-bar-message mt-1"} style={{}}>
            {"Please"}{" "}
            <span className={"Save-click"} onClick={this.updateTenantValues}>
              {"Click Here\r"}
            </span>{" "}
            {"to save the changes.\r"}
          </div>
        ) : null}
        {this.state.tableName == "lease" && IsTenantListingPermissionVisible ? (
          <table
            className={"site-profile-table"}
            style={{ fontWeight: "200 !important" }}
          >
            <thead>
              <tr
                className={"blue-custom-title"}
                style={{ borderTop: "3px solid #FFFFFF" }}
              >
                <th className={"w-20"}>{"Tenant "}</th>
                <th className={"w-10"} colSpan={2} style={{ textAlign: "right" }}>
                  {"Power Leased"}{" "}
                </th>
                <th>
                  {IsTenantListingPermissionEditable && (
                    <>
                      {this.state.editFields == false ? (
                        moment(this.props.endDate).format("YYYY-MM") >=
                        moment()
                          .subtract(2, "months")
                          .format("YYYY-MM") ? (
                          <Tooltip title={"Edit Records"} placement={"bottom"}>
                            <EditIcon
                              fontSize={"small"}
                              style={{
                                color: "#FFFFFF",
                                fontSize: "15px",
                                cursor: "pointer"
                              }}
                              onClick={() => {
                                this.setState({ editFields: true });
                              }}
                            />
                          </Tooltip>
                        ) : null
                      ) : (
                        <Tooltip
                          title={"Cancel Editing Records"}
                          placement={"bottom"}
                        >
                          <CancelIcon
                            fontSize={"small"}
                            style={{
                              color: "#FFFFFF",
                              fontSize: "15px",
                              cursor: "pointer"
                            }}
                            onClick={() => {
                              this.setState({
                                editFields: false,
                                ValuesToUpdate: []
                              });
                            }}
                          />
                        </Tooltip>
                      )}
                    </>
                  )}
                </th>

                <th className={"w-10"} style={{ textAlign: "right" }}>
                  {" "}
                  {"Sq Ft Leased\r"}
                </th>
                <th className={"w-10"} style={{ paddingLeft: "15px" }}>
                  {" "}
                  {"Suite\r"}
                </th>
                <th className={"w-40"}>{" Notes"}</th>
                <th className={"w-10 tc"}>{"Contact Details"}</th>
              </tr>
            </thead>
            <tbody>
              {siteProfileTableList.length > 0 ? (
                (siteProfileTableList || []).map((item, index) => (
                  <tr key={"siteProfileTableList" + index}>
                    <td>{item.TenantName}</td>
                    <td style={{ textAlign: "right" }}>
                      {this.state.editFields == true &&
                      IsTenantListingPermissionEditable ? (
                        <TextField
                          className={"editablePowerInput"}
                          id={"standard-basic"}
                          size={"small"}
                          type={"text"}
                          inputProps={{ maxLength: 15 }}
                          defaultValue={
                            isNaN(parseFloat(item.PowerLeased)) == true
                              ? ""
                              : parseFloat(item.PowerLeased)
                          }
                          onBlur={event => {
                            this.handleChangeValue(
                              event.target.value,
                              item.TenantDetailId
                            );
                          }}
                        />
                      ) : item.PowerLeased != null && item.PowerLeased != 0 ? (
                        numberWithCommas(parseFloat(item.PowerLeased))
                      ) : (
                        "-"
                      )}
                    </td>
                    <td style={{ paddingLeft: "0px" }} colSpan={2}>
                      {" "}
                      {item.PowerLeased != null && item.PowerLeased != 0
                        ? "kW"
                        : null}
                    </td>
                    <td style={{ textAlign: "right" }}>
                      {" "}
                      {item.SqFt == 0 || item.SqFt == null
                        ? "-"
                        : item.SqFt.toLocaleString() + " sq ft"}
                    </td>
                    <td style={{ paddingLeft: "15px" }}>
                      {item.Suite == null ? "-" : item.Suite}
                    </td>

                    <td>
                      {" "}
                      {item.Notes == null || item.Notes == ""
                        ? "-"
                        : item.Notes}
                    </td>
                    <td className={"tc"}>
                      <Tooltip title={"View Contact Details"} placement={"top"}>
                        <VisibilityIcon
                          fontSize={"inherit"}
                          size={"small"}
                          style={{ cursor: "pointer" }}
                          onClick={() => this.handleClickOpen(index)}
                        />
                      </Tooltip>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td style={{ textAlign: "center" }} colSpan={8}>
                    {"No data available\r"}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        ) : (
          IsDataHallPermissionVisible && (
            <>
              <table
                className={"site-profile-table"}
                style={{ fontWeight: "200 !important" }}
              >
                <thead>
                  <tr
                    className={"blue-custom-title"}
                    style={{ borderTop: "3px solid #FFFFFF" }}
                  >
                    <th className={"w-20"}>{" Data Hall Capacity"}</th>
                    <th
                      className={"w-10"}
                      colSpan={2}
                      style={{ textAlign: "right" }}
                    >
                      {" "}
                      {"Power\r"}
                    </th>
                    <th>
                      {" "}
                      {IsDataHallPermissionEditable && (
                        <>
                          {" "}
                          {this.state.editCapacity == false ? (
                            moment(this.props.endDate).format("YYYY-MM") >=
                            moment()
                              .subtract(2, "months")
                              .format("YYYY-MM") ? (
                              <Tooltip title={"Edit Records"} placement={"bottom"}>
                                <EditIcon
                                  fontSize={"small"}
                                  style={{
                                    color: "#FFFFFF",
                                    fontSize: "15px",
                                    cursor: "pointer"
                                  }}
                                  onClick={() => {
                                    this.setState({ editCapacity: true });
                                  }}
                                />
                              </Tooltip>
                            ) : null
                          ) : (
                            <Tooltip
                              title={"Cancel Editing Records"}
                              placement={"bottom"}
                            >
                              <CancelIcon
                                fontSize={"small"}
                                style={{
                                  color: "#FFFFFF",
                                  fontSize: "15px",
                                  cursor: "pointer"
                                }}
                                onClick={() => {
                                  this.setState({ editCapacity: false });
                                }}
                              />
                            </Tooltip>
                          )}
                        </>
                      )}
                    </th>
                    <th className={"w-10"} style={{ textAlign: "right" }}>
                      {" "}
                      {"Sq Ft\r"}
                    </th>
                    <th className={"w-70"} style={{ textAlign: "right" }}>
                      {" "}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {// siteProfileTableList.length > 0 ? (
                  (this.state.siteProfileCapacityTableList || []).map(
                    (item) => (
                      <tr>
                        <td>{item.AttributeName} </td>

                        <td style={{ textAlign: "right" }}>
                          {item.IsEditable == 1 &&
                          IsDataHallPermissionEditable &&
                          this.state.editCapacity == true ? (
                            <TextField
                              className={"editableTextInput"}
                              id={"standard-basic"}
                              size={"small"}
                              type={"text"}
                              defaultValue={
                                isNaN(parseFloat(item.Power)) == true
                                  ? ""
                                  : parseFloat(item.Power)
                              }
                              onBlur={event => {
                                this.handleChange(
                                  event.target.value,
                                  item.SectionDetailId
                                );
                              }}
                            />
                          ) : item.Power != null ? (
                            numberWithCommas(item.Power)
                          ) : (
                            "-"
                          )}
                        </td>
                        <td style={{ paddingLeft: "0px" }} colSpan={2}>
                          {item.Power != null ? "kW" : null}{" "}
                        </td>
                        <td style={{ textAlign: "right" }}>
                          {item.SqFt != null
                            ? item.SqFt.toLocaleString() + " sq ft"
                            : "-"}
                        </td>
                        <td />
                      </tr>
                    )
                  )
                  // ) : (
                  //   <tr>
                  //     <td style={{ textAlign: "center" }} colSpan={6}>
                  //       No data available
                  //     </td>
                  //   </tr>
                  // )
                  }
                </tbody>
              </table>
            </>
          )
        )}
        <div>
          <Dialog
            open={this.state.open}
            onClose={this.handleClose}
            aria-labelledby={"responsive-dialog-title"}
            PaperComponent={PaperComponent}
            maxWidth={"lg"}
            fullWidth
          >
            <DialogTitle
              style={{ cursor: "move" }}
              id={"responsive-dialog-title"}
            >
              {"Contact Details\r"}
            </DialogTitle>

            <DialogContent>
              <DialogContentText>
                <TenantContact
                  tenantId={selectedTenantId}
                />
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleClose} color={"primary"}>
                {"Close\r"}
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      </div>
    );
  }
}

export default SiteProfileTable;
